import request from "@/request/request";
export function login(data) {
  return request({
    url: '/ja/auth/login',
    method: 'post',
    data
  })
}
export function logout() {
  return request({
    url: '/ja/auth/logout',
    method: 'get'
  })
}
// 获取用户列表
export function getListUser(data) {
 return request({
    url: '/ja/clientUser/listUser',
    method: 'post',
    data
  })
}
// 获取用户档案列表
export function getListUserArchive(data) {
 return request({
    url: '/ja/clientUser/pageUser',
    method: 'post',
    data
  })
}
// 新增用户
export function addUser(data) {
 return request({
    url: '/ja/clientUser/add',
    method: 'post',
    data
  })
}
// 修改用户
export function updateUser(data) {
 return request({
    url: '/ja/clientUser/update',
    method: 'post',
    data
  })
}
// 分页查询评估记录
export function getListRecord(data) {
 return request({
    url: '/ja/clientUser/pageEva',
    method: 'post',
    data
  })
}
// 分页查询训练记录
export function getListTrainRecord(data) {
 return request({
    url: '/ja/clientUser/pageTrain',
    method: 'post',
    data
  })
}
// 获取系统介绍
export function getSystemIntroduce(params) {
 return request({
    url: '/ja/sys/listIntroduce',
    method: 'get',
    params
  })
}
// 查询未完成评估
export function getUnfinishedEva(params) {
 return request({
    url: '/ja/eva/getUnFinished',
    method: 'get',
    params
  })
}
// 清空未完成评估
export function clearUnfinishedEva(params) {
 return request({
    url: '/ja/eva/endEva',
    method: 'post',
    params
  })
}
// 勋章墙数据查询
export function getMedalWall(params) {
 return request({
    url: '/ja/medalWall/list',
    method: 'get',
    params
  })
}
// 查询人脸结果
export function getFaceResult(data) {
 return request({
    url: '/ja/clientUser/searchByTopFace',
    method: 'post',
    data
  })
}
export function getUploadToken(params) {
  return request({
    url: 'ja/oss/upToken',
    method: 'get',
    params
  })
}
// 查询机构信息
export function getOrgInfo(params) {
 return request({
    url: '/ja/sys/getInstitutionInfo',
    method: 'get',
    params
  })
}
// 修改密码
export function updatePassword(data) {
 return request({
    url: '/ja/sys/updatePwd',
    method: 'post',
    data
  })
}
// 查询精灵显示隐藏
export function getSpriteStatus(params) {
 return request({
    url: '/ja/institutionConfig/getSpiritSwitch',
    method: 'get',
    params
  })
}
// 设置精灵状态
export function setSpriteStatus(params) {
 return request({
    url: '/ja/institutionConfig/setSpiritSwitch',
    method: 'post',
    params
  })
}